export default __webpack_public_path__ + "static/media/mayo-logo.2ffe3769.png";